module.exports = __webpack_public_path__ + "media/images/carousel/banner_11-ecbbe466cf9f3605f2a16a63146edd27.jpg";